export default "https://cdn-static.gokick.com/assets/f782299a76cdb7f85e2c64a970a00c34ce21ab93/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";